import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HomeHero from './components/HomeHero';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import LatestContent from './components/LatestContent';
import HomeFAQ from './components/HomeFAQ';
import SchemaOrg from '@/components/feature/SchemaOrg';

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "亚洲精品一区二区",
  "url": "https://tsdtys3.cn",
  "description": "亚洲精品一区二区为您提供专业分区内容导览，涵盖一区精品推荐与二区优质资源，精准分类、快速定位，满足您对亚洲精品内容的多样化需求。",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://tsdtys3.cn/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "亚洲精品一区二区",
  "url": "https://tsdtys3.cn",
  "description": "精选内容分区导览平台，汇聚亚洲优质内容，提供精准分类、快速定位的内容发现服务。",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "400-888-9999",
    "contactType": "customer service",
    "availableLanguage": ["Chinese"]
  }
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "亚洲精品一区二区是什么？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "亚洲精品一区二区是一个专注于亚洲精品内容聚合与分区导览的平台，通过一区精品推荐和二区优质资源两大核心板块，为用户提供精准分类、快速定位的内容发现服务。"
      }
    },
    {
      "@type": "Question",
      "name": "一区和二区的内容有什么区别？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "一区精品推荐主要涵盖编辑精选、热门推荐、深度好文和专题策划类内容，侧重于内容的品质把控和专业编辑筛选；二区优质资源聚焦于资源聚合、精品合集、热门资源和特色专栏，更加注重资源的全面性和多样性。"
      }
    },
    {
      "@type": "Question",
      "name": "如何快速找到我感兴趣的内容？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "您可以通过首页的分类导航卡片进入对应分区，在分类页面通过子分类标签精准筛选，利用搜索功能输入关键词查找，或浏览首页的精选推荐和最新内容板块发现优质内容。"
      }
    },
    {
      "@type": "Question",
      "name": "平台上的内容多久更新一次？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "平台内容保持每日更新，编辑团队会持续筛选和发布最新精品内容。最新上线板块实时展示今日更新内容，确保您第一时间获取新鲜资源。"
      }
    },
    {
      "@type": "Question",
      "name": "如何区分编辑精选和普通内容？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "编辑精选内容会在标题旁显示精选标识，这些内容经过编辑团队从原创性、信息准确性、表达质量、视觉呈现、用户价值和时效性六个维度严格评审，总分达到90分以上才能获得此标识。"
      }
    }
  ]
};

export default function Home() {
  return (
    <>
      <SchemaOrg schema={homeSchema} />
      <SchemaOrg schema={orgSchema} />
      <SchemaOrg schema={faqSchema} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HomeHero />
        <CategoryCards />
        <FeaturedArticles />
        <LatestContent />
        <HomeFAQ />
      </main>
      <Footer />
    </>
  );
}